import { call, put, select } from 'redux-saga/effects'
import { ApiType } from '../Services/api'
import ReminderActions from '../Redux/reminderRedux'
import ErrorActions from '../Redux/errorRedux'
import { getGeneralApiProblem } from '../Utils/reduxHelpers'
import { ReminderSettings } from '../interfaces'
import { handleCallbacks } from '../Utils/helpers'
import {UIState} from "../Redux/uiRedux";

interface ActionType {
    type: string
}

type Callbacks = (() => void)[]

interface ReminderAction extends ActionType {
    settings: ReminderSettings,
    callbacks?: Callbacks
}

export function* postReminderSettings(
    api: ApiType,
    action: ReminderAction,
): unknown {

    const chainId = yield select(({ ui: { settings } }: { ui: UIState }) => settings?.chain?.id)
    const stationId = yield select(({ ui: { settings } }: { ui: UIState }) => settings?.station?.id)

    const response = yield call(api.postReminderSettings, chainId, stationId, action.settings)
    if (response.ok) {
        const { data } = response
        yield put(ReminderActions.postReminderSettingsSuccess(data))
        yield handleCallbacks(action.callbacks)
    } else if (response.problem) {
        const problem = response.status === 409 ? 'errors.timeNotAvailable' : getGeneralApiProblem(response.problem, response.status)
        yield put(ErrorActions.setError(problem))
        yield put(ReminderActions.postReminderSettingsFailure())
    }
}
